import { withAuthorization } from "../../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../../structure/Page/DefaultPage/DefaultPage";

const BillRemindersOverviewPageContent = lazy(() => import("./BillRemindersOverviewPageContent"));

function BillRemindersOverviewPageInternal() {
    return (
        <DefaultPage>
            <BillRemindersOverviewPageContent />
        </DefaultPage>
    );
}

export const BillRemindersOverviewPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    BillRemindersOverviewPageInternal
);
